// removed by extract-text-webpack-plugin
module.exports = {"select":"f0jC1","input":"_36qW5"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Select/index.sass
// module id = 1502
// module chunks = 1